export enum NewMatchWeeklyFrequency {
    EveryOneWeek = 0,
    EveryTwoWeeks = 1,
    EveryThreeWeeks = 2,
    EveryFourWeeks = 3
}